export default {
    "北京": [116.3972, 39.9329],
    "天津": [117.2, 39.0841],
    "上海": [121.4737, 31.2303],
    "重庆": [106.5515, 29.5630],
    "河北": [114.4686, 38.0370],
    "唐山": [118.1804, 39.6304],
    "邯郸": [114.5390, 36.6256],
    "邢台": [114.5048, 37.0705],
    "和田": [79.928617114756, 37.1203963885906],
    "巴音郭楞蒙古自治州": [86.1523202981036, 41.7704831738069],
    "保定": [115.4648, 38.8378],
    "承德": [117.9624, 40.9540],
    "黑龙江": [126.6625, 45.7421],
    "大庆": [125.1046, 46.5901],
    "鸡西": [130.9693, 46.2950],
    "伊春": [128.8406, 47.7275],
    "鹤岗": [130.2981, 47.3499],
    "黑河": [127.5284, 50.2452],
    "香河": [117.012492379233, 39.7677586417572],
    "绥化": [126.9800, 46.6366],
    "吉林": [125.3260, 43.8960],
    "吉林": [126.5563, 43.8425],
    "长春": [125.3235, 43.8170],
    "四平": [124.3503, 43.1664],
    "辽源": [125.1435, 42.8879],
    "通化": [125.9396, 41.7284],
    "白山": [126.4235, 41.9399],
    "松原": [124.8251, 45.1417],
    "白城": [122.8390, 45.6196],
    "延边": [129.5089, 42.8912],
    "辽宁": [123.4294, 41.8354],
    "沈阳": [123.4314, 41.8057],
    "大连": [121.6146, 38.9140],
    "锡林郭勒盟": [116.094790649772, 43.9518694270503],
    "鞍山": [122.9946, 41.1085],
    "抚顺": [123.9572, 41.8808],
    "本溪": [123.7664, 41.2941],
    "丹东": [124.3849, 40.1273],
    "锦州": [121.1270, 41.0951],
    "营口": [122.2354, 40.6670],
    "阜新": [121.6703, 42.0216],
    "辽阳": [123.1728, 41.2694],
    "德清": [119.984001, 30.548828],
    "盘锦": [122.0707, 41.1199],
    "铁岭": [123.7261, 42.2229],
    "沧州": [116.872499169006, 38.3187095338524],
    "朝阳": [120.4503, 41.5737],
    "包头": [109.8403, 40.6574],
    "乌海": [106.7942, 39.6550],
    "河池": [108.068433606602, 24.7028772375693],
    "赤峰": [118.8868, 42.2578],
    "通辽": [122.2657, 43.6194],
    "昌吉": [87.3082, 44.0111],
    "海东地区": [102.092800126328, 36.5151331379023],
    "伊犁州": [81.3240, 43.9168],
    "山西": [112.5625, 37.8733],
    "阳泉": [113.5804, 37.8566],
    "晋城": [112.8517, 35.4908],
    "朔州": [112.4328, 39.3315],
    "吴江": [120.645560078294, 31.16355713255],
    "忻州": [112.7341, 38.4166],
    "临汾": [111.5188, 36.0880],
    "吕梁": [111.1443, 37.5183],
    "长治": [113.1162, 36.1953],
    "运城": [111.0073, 35.0263],
    "晋中": [112.7526, 37.6870],
    "大同": [113.3001, 40.0768],
    "太原": [112.5506, 37.8706],
    "陕西": [108.9542, 34.2654],
    "西安": [108.9442, 34.2498],
    "宝鸡": [107.2375, 34.3620],
    "咸阳": [108.7090, 34.3295],
    "渭南": [109.5097, 34.4999],
    "铜川": [108.9451, 34.8967],
    "延安": [109.4896, 36.5854],
    "喀什": [75.9962398996083, 39.4763985427789],
    "榆林": [109.7345, 38.2853],
    "防城港": [108.360258947283, 21.6931644271779],
    "汉中": [107.0233, 33.0674],
    "建德": [119.287718, 29.481161],
    "固安": [116.305068308837, 39.4444001149127],
    "安康": [109.0293, 32.6847],
    "商洛": [109.9404, 33.8704],
    "钦州": [108.615148857608, 21.957147647928],
    "银川": [106.2309, 38.4871],
    "固原": [106.2426, 36.0158],
    "甘南藏族自治州": [102.911343139277, 34.9873012176762],
    "吴忠": [106.1982, 37.9974],
    "中卫": [105.1738, 37.5168],
    "德宏傣族景颇族自治州": [98.5908535696204, 24.4395715005159],
    "延边朝鲜族自治州": [129.504083015879, 42.9003878992238],
    "晋江": [118.582908653326, 24.8211574064428],
    "甘肃": [103.8263, 36.0594],
    "兰州": [103.8343, 36.0162],
    "金昌": [102.1880, 38.5200],
    "武威": [102.6380, 37.9283],
    "酒泉": [98.4944, 39.7324],
    "张掖": [100.4498, 38.9256],
    "昆山": [120.98267518967, 31.3919479161388],
    "新昌": [120.910429784904, 29.5054705446051],
    "白银": [104.1376, 36.5448],
    "平凉": [106.6651, 35.5426],
    "启东": [121.658923974576, 31.814268382961],
    "庆阳": [107.6324, 35.7386],
    "天水": [105.7249, 34.2505],
    "陇南": [104.9220, 33.4007],
    "定西": [104.6262, 35.5806],
    "临夏": [103.2105, 35.6011],
    "甘南州": [102.9112, 34.9832],
    "青海": [101.7801, 36.6208],
    "西宁": [101.7782, 36.6171],
    "海西州": [97.3697, 37.3771],
    "海南州": [100.6203, 36.2864],
    "海北州": [100.9009, 36.9542],
    "河南": [113.6872, 34.7681],
    "郑州": [113.63512, 34.756861],
    "新乡": [113.9268, 35.3030],
    "洛阳": [112.44, 34.7],
    "安阳": [114.3927, 36.0975],
    "焦作": [113.2418, 35.2158],
    "许昌": [113.8526, 34.0355],
    "漯河": [114.0165, 33.5814],
    "开封": [114.3075, 34.7972],
    "濮阳": [115.0293, 35.7621],
    "鹤壁": [114.2972, 35.7472],
    "南阳": [112.5283, 32.9906],
    "商丘": [115.6563, 34.4141],
    "塔城": [82.9869453907727, 46.7511083727777],
    "信阳": [114.0912, 32.1470],
    "周口": [114.6576, 33.6186],
    "山东": [117.0204, 36.6686],
    "济南": [116.9949, 36.6652],
    "青岛": [120.3825, 36.0672],
    "淄博": [118.0550, 36.8134],
    "枣庄": [117.3237, 34.8104],
    "东营": [118.6747, 37.4347],
    "烟台": [121.4479, 37.4638],
    "潍坊": [119.1619, 36.7066],
    "济宁": [116.5870, 35.4149],
    "桐乡": [120.571493, 30.63616],
    "泰安": [117.0876, 36.2002],
    "威海": [122.1204, 37.5130],
    "黔东南苗族侗族自治州": [107.987459441076, 26.5892407533488],
    "日照": [119.5268, 35.4163],
    "燕郊": [116.811328931161, 39.9502496713992],
    "滨州": [117.9707, 37.3819],
    "涿州": [115.981038603139, 39.4909485804126],
    "德州": [116.3574, 37.4340],
    "聊城": [115.9853, 36.4567],
    "临沂": [118.3564, 35.1046],
    "菏泽": [115.480656, 35.2337],
    "莱芜": [117.6767, 36.2136],
    "江苏": [118.7632, 32.0617],
    "红河哈尼族彝族自治州": [103.186520243009, 23.4362907038259],
    "博尔塔拉蒙古自治州": [82.0850979555107, 44.9188071937634],
    "海南藏族自治州": [100.644272311043, 36.3301955428686],
    "凉山彝族自治州": [102.24869164582, 27.915821018251],
    "南京": [118.7968, 32.0602],
    "无锡": [120.3030, 31.5661],
    "徐州": [117.2840, 34.2047],
    "常州": [119.9744, 31.8100],
    "苏州": [120.5853, 31.2988],
    "南通": [120.8943, 31.9801],
    "淮安": [119.0152, 33.6103],
    "盐城": [120.1635, 33.3473],
    "扬州": [119.4129, 32.3942],
    "镇江": [119.4572, 32.1991],
    "泰州": [119.9231, 32.4557],
    "宿迁": [118.2754, 33.9619],
    "嵊州": [120.837188, 29.567465],
    "淳安": [119.048382, 29.614979],
    "安徽": [117.2849, 31.8611],
    "合肥": [117.2272, 31.8214],
    "屯昌": [110.10456032354, 19.3697960967686],
    "芜湖": [118.4329, 31.3528],
    "安庆": [117.0568, 30.5248],
    "蚌埠": [117.3897, 32.9162],
    "铜陵": [117.8108, 30.9445],
    "阜阳": [115.8142, 32.8901],
    "衡水": [115.704934420215, 37.7415621774791],
    "乌鲁木齐": [87.6124843849905, 43.7971846976002],
    "黄山": [118.3374, 29.7146],
    "淮北": [116.7982, 33.9558],
    "滁州": [118.3171, 32.3015],
    "淮南": [116.7982, 33.9558],
    "巢湖": [117.8647, 31.5978],
    "六安": [116.5056, 31.7450],
    "池州": [117.4915, 30.6648],
    "黄南藏族自治州": [101.822970455279, 35.4697956509268],
    "乌兰察布": [113.127641434509, 41.0375525536163],
    "宣城": [118.7588, 30.9407],
    "毫州": [115.7786, 33.8445],
    "临安": [119.731318, 30.239745],
    "宿州": [116.9853, 33.6393],
    "北海": [109.12570070289, 21.4856460970652],
    "湖北": [114.3419, 30.5458],
    "武汉": [114.3053, 30.5930],
    "黄石": [115.0385, 30.1996],
    "襄阳": [112.1224, 32.0089],
    "荆州": [112.2397, 30.3351],
    "宜昌": [111.2864, 30.6919],
    "十堰": [110.7979, 32.6293],
    "孝感": [113.9169, 30.9245],
    "荆门": [112.1992, 31.0354],
    "大厂": [116.995980008427, 39.8928441012952],
    "鄂州": [114.8948, 30.3919],
    "海北藏族自治州": [100.979500883832, 36.94902643539],
    "迪庆藏族自治州": [99.708563376735, 27.8252916793058],
    "怒江傈僳族自治州": [98.8626394141762, 25.8579750328103],
    "巴彦淖尔": [107.394049318877, 40.7494659345349],
    "黔南布依族苗族自治州": [107.517723281641, 26.2893253289053],
    "黄冈": [114.8723, 30.4539],
    "贺州": [111.569371926006, 24.4337859354225],
    "咸宁": [114.3224, 29.8414],
    "随州": [113.3824, 31.6902],
    "西昌": [102.270921460705, 27.9005895524997],
    "潜江": [112.9000, 30.4021],
    "襄樊": [116.41390548544, 39.9103511409211],
    "仙桃": [113.4545, 30.3626],
    "天门": [113.1665, 30.6633],
    "恩施": [109.4881, 30.2721],
    "湖南": [112.9838, 28.1124],
    "长沙": [112.9388, 28.2282],
    "株洲": [113.1337, 27.8278],
    "湘潭": [112.9440, 27.8297],
    "衡阳": [112.5719, 26.8938],
    "邵阳": [111.4677, 27.2388],
    "岳阳": [113.1289, 29.3271],
    "常德": [111.6984, 29.0316],
    "益阳": [112.3551, 28.5538],
    "郴州": [113.0147, 25.7705],
    "永州": [111.6134, 26.4203],
    "怀化": [109.9984, 27.5549],
    "崇左": [107.346008272741, 22.4304941933354],
    "娄底": [109.9984, 27.5549],
    "湘西": [109.7391, 28.3119],
    "贵州": [106.7071, 26.5980],
    "贵阳": [106.6301, 26.6474],
    "亳州": [115.789023057318, 33.8758130168604],
    "遵义": [106.9273, 27.7256],
    "安顺": [105.9475, 26.2530],
    "毕节": [105.3051, 27.2984],
    "黔南州": [107.5221, 26.2540],
    "四川": [104.0759, 30.6516],
    "成都": [104.0648, 30.6586],
    "德阳": [104.3980, 31.1268],
    "绵阳": [104.6791, 31.4674],
    "广元": [105.8433, 32.4354],
    "巴中": [106.7447, 31.8652],
    "广安": [106.6332, 30.4559],
    "资阳": [104.6276, 30.1289],
    "自贡": [104.7784, 29.3390],
    "泸州": [105.4423, 28.8718],
    "常熟": [120.753948573245, 31.6599966948585],
    "南充": [106.1106, 30.8377],
    "达州": [107.4680, 31.2095],
    "乐山": [103.7655, 29.5521],
    "雅安": [103.0132, 29.9205],
    "宜宾": [104.6433, 28.7518],
    "内江": [105.0584, 29.5802],
    "眉山": [103.8485, 30.0754],
    "遂宁": [105.5928, 30.5328],
    "阿坝州": [102.2246, 31.8994],
    "甘孜州": [101.9623, 30.0495],
    "凉山州": [102.2673, 27.8816],
    "云南": [102.7098, 25.0453],
    "昆明": [102.7222, 25.0377],
    "曲靖": [103.7961, 25.4900],
    "武夷山": [118.04188622114, 27.7623980105433],
    "彭山": [103.879508416714, 30.1988037895668],
    "玉溪": [102.5465, 24.3520],
    "百色": [106.625198293247, 23.9075649775201],
    "保山": [99.1614, 25.1120],
    "昭通": [103.7174, 27.3382],
    "丽江": [100.2303, 26.8767],
    "伊犁哈萨克自治州": [81.3447763216707, 43.9293576857891],
    "普洱": [100.9701, 22.7777],
    "太仓": [121.110384911845, 31.4559284574012],
    "临沧": [100.0795, 23.8775],
    "楚雄州": [101.5280, 25.0455],
    "大理州": [100.2676, 25.6064],
    "红河州": [103.3747, 23.3631],
    "文山": [104.2510, 23.3688],
    "德宏州": [98.5848, 24.4333],
    "怒江州": [98.8530, 25.8525],
    "迪庆州": [99.7022, 27.8188],
    "拉萨": [91.1408, 29.6455],
    "江西": [115.9091, 28.6744],
    "南昌": [115.8580, 28.6831],
    "九江": [116.0019, 29.7051],
    "上饶": [117.9434, 28.4548],
    "萍乡": [113.8546, 27.6228],
    "新余": [114.9174, 27.8178],
    "鹰潭": [117.0692, 28.2601],
    "贵港": [109.605440108416, 23.117379615104],
    "赣州": [114.9350, 25.8319],
    "宜春": [114.4167, 27.8156],
    "吉安": [114.9929, 27.1130],
    "抚州": [116.3581, 27.9492],
    "浙江": [120.1536, 30.2658],
    "杭州": [120.1550, 30.2740],
    "宁波": [121.5439, 29.8683],
    "温州": [120.6993, 27.9942],
    "嘉兴": [120.7585, 30.7539],
    "湖州": [120.0868, 30.8943],
    "绍兴": [120.5861, 29.9957],
    "金华": [119.6474, 29.0790],
    "衢州": [118.8743, 28.9358],
    "舟山": [122.2066, 29.9854],
    "台州": [121.4207, 28.6563],
    "海宁": [120.686795, 30.517367],
    "丽水": [119.9227, 28.4676],
    "福建": [119.2965, 26.0999],
    "厦门": [118.0894, 24.4798],
    "福州": [119.2964, 26.0745],
    "泉州": [118.5868, 24.9075],
    "莆田": [119.0077, 25.4540],
    "张家港": [120.557197233971, 31.8810932435566],
    "三明": [117.6386, 26.2634],
    "哈密": [93.521426248629, 42.8244211523078],
    "漳州": [117.6474, 24.5129],
    "南平": [118.1777, 26.6417],
    "龙岩": [117.0177, 25.0751],
    "宁德": [119.5479, 26.6656],
    "广东": [113.2665, 23.1321],
    "广州": [113.2644, 23.1291],
    "深圳": [114.0578, 22.5430],
    "珠海": [113.5767, 22.2707],
    "义乌": [120.08186, 29.311714],
    "汕头": [116.6818, 23.3532],
    "佛山": [113.1214, 23.0215],
    "宜兴": [119.823891089817, 31.3442863732393],
    "韶关": [113.5975, 24.8104],
    "湛江": [110.3593, 21.2707],
    "肇庆": [112.4650, 23.0471],
    "江门": [113.0819, 22.5787],
    "茂名": [110.9254, 21.6629],
    "惠州": [114.4161, 23.1118],
    "梅州": [116.1224, 24.2883],
    "汕尾": [115.3752, 22.7862],
    "河源": [114.7004, 23.7435],
    "阳江": [111.9822, 21.8579],
    "清远": [113.0560, 23.6817],
    "东莞": [113.7517, 23.0205],
    "中山": [113.3927, 22.5166],
    "潮州": [116.6225, 23.6569],
    "三河": [117.084812952189, 24.3312939315453],
    "揭阳": [116.3728, 23.5499],
    "江阴": [120.286494328255, 31.9264946453355],
    "云浮": [112.0444, 22.9250],
    "桂林": [110.293093117839, 25.2881899835745],
    "海南": [110.3492, 20.0173],
    "海南": [110.3492, 20.0173],
    "海口": [110.3288, 20.0307],
    "三亚": [110.3288, 20.0307],
    "琼海": [110.4746, 19.2584],
    "儋州": [109.5808, 19.5211],
    "文昌": [110.7976, 19.5433],
    "万宁": [110.3910, 18.7951],
    "铜仁地区": [109.194088004939, 27.7246710839742],
    "呼伦贝尔": [119.762179327509, 49.25214781092],
    "东方": [108.6517, 19.0953],
    "澄迈": [110.0067, 19.7385],
    "西双版纳": [100.804216443441, 22.0136529578129],
    "定安": [110.3284, 19.6973],
    "从化": [113.593186017607, 23.5545334382268],
    "桐庐": [119.698761, 29.798675],
    "梧州": [111.311017750889, 23.5092290321465],
    "临高": [109.6905, 19.9120],
    "柳州": [109.422408646857, 24.3315963959724],
    "白沙": [109.4514, 19.2248],
    "昌江": [109.0541, 19.2602],
    "乐东": [109.1730, 18.7502],
    "陵水": [110.0375, 18.5060],
    "保亭": [109.7025, 18.6391],
    "琼中": [109.8383, 19.0333],
    "台湾": [120.9605, 23.6978],
    "基隆": [121.7081, 25.1089],
    "台北": [121.5598, 25.0910],
    "新竹": [120.9646, 24.8039],
    "台中": [120.9417, 24.2332],
    "嘉义": [120.4472, 23.4754],
    "台南": [120.2512, 23.1416],
    "高雄": [120.6660, 23.0108],
    "香港": [114.1094, 22.3964],
    "澳门": [113.5438, 22.1987],
    "石家庄": [114.5148, 38.0423],
    "秦皇岛": [119.6004, 39.9353],
    "玉林": [110.157146402977, 22.6318169910892],
    "张家口": [114.8875, 40.8244],
    "哈尔滨": [126.5349, 45.8037],
    "齐齐哈": [123.9181, 47.3543],
    "牡丹江": [129.6331, 44.5516],
    "佳木斯": [130.3189, 46.7999],
    "吐鲁番": [89.1961397791757, 42.9573811182154],
    "双鸭山": [131.1595, 46.6469],
    "七台河": [131.0049, 45.7719],
    "葫芦岛": [120.8369, 40.7110],
    "内蒙古": [111.7656, 40.8174],
    "呼和浩": [111.7488, 40.8423],
    "鄂尔多": [109.7813, 39.6082],
    "呼伦贝": [119.7657, 49.2115],
    "巴彦淖": [107.3876, 40.7432],
    "乌兰察": [113.1325, 40.9947],
    "新疆": [87.6168, 43.8256],
    "乌鲁木": [87.6168, 43.8256],
    "克拉玛": [84.8892, 45.5798],
    "石河子": [86.0804, 44.3061],
    "阿克苏": [80.2610, 41.1683],
    "宁夏": [106.4713, 38.4713],
    "石嘴山": [106.3830, 38.9843],
    "嘉峪关": [98.2891, 39.7731],
    "海东地": [102.1043, 36.5022],
    "平顶山": [113.1928, 33.7661],
    "三门峡": [111.2002, 34.7724],
    "驻马店": [114.0222, 33.0115],
    "连云港": [119.2212, 34.5965],
    "马鞍山": [118.5067, 31.6704],
    "张家界": [110.4791, 29.1170],
    "六盘水": [104.8303, 26.5926],
    "铜仁地": [109.1895, 27.7315],
    "黔西南": [104.9063, 25.0878],
    "黔东南": [107.9828, 26.5835],
    "毕节地": [105.2839, 27.3025],
    "攀枝花": [101.7186, 26.5823],
    "西双版": [100.7973, 22.0081],
    "西藏": [91.1170, 29.6479],
    "昌都地": [97.1720, 31.1409],
    "林芝地": [94.3614, 29.6491],
    "山南地": [91.7731, 29.2371],
    "日喀则": [88.8805, 29.2668],
    "那曲地": [92.0512, 31.4761],
    "阿里地": [80.1056, 32.5010],
    "景德镇": [117.1784, 29.2688],
    "克拉玛依": [84.9376404141442, 45.6023715663742],
    "五指山": [109.5169, 18.7751],
    "黔西南布依族苗族自治州": [104.911577832148, 25.0941479435575],
    "来宾": [109.24, 23.76],
    "南宁": [108.315197, 22.826393],
    "廊坊": [
        '116.705',
        '39.5363'
    ],
    "呼和浩特": [
        '111.669936911091',
        '40.8266180307726'
    ],
    "甘孜藏族自治州": [
        '101.958664409458',
        '30.0640519102787'
    ],
    "克孜勒苏柯尔克孜自治州": [
        '76.1754776705766',
        '39.720846295973'
    ],
    "海西蒙古族藏族自治州": [
        '97.3773894735948',
        '37.3804062120114'
    ],
    '海门': [121.15, 31.89],
    '鄂尔多斯': [109.781327, 39.608266],
    '招远': [120.38, 37.35],
    '舟山': [122.207216, 29.985295],
    '齐齐哈尔': [123.97, 47.33]
}